import { useMedia } from 'tamagui'

/**
 * Select a value from an array based on the current breakpoint.
 * Replaces the legacy `selectBreakpointToken(useBreakpoint(), values)` pattern.
 *
 * Breakpoint mapping:
 *   0 = xs (mobile)
 *   1 = sm (gtXs)
 *   2 = md (gtSm)
 *   3 = lg (gtMd)
 *   4 = xl (gtLg)
 *
 * If the array has fewer items than breakpoints, clamps to the last value.
 */
export const useBreakpointValue = <T>(values: T | T[]): T => {
  const media = useMedia()

  if (!Array.isArray(values)) {
    return values
  }

  let index = 0
  if (media.gtXs) index = 1
  if (media.gtSm) index = 2
  if (media.gtMd) index = 3
  if (media.gtLg) index = 4

  return values[Math.min(index, values.length - 1)]
}

/**
 * Returns the current breakpoint index (0-4) for use in computations
 * that need the raw index value.
 */
export const useBreakpointIndex = (): number => {
  const media = useMedia()

  let index = 0
  if (media.gtXs) index = 1
  if (media.gtSm) index = 2
  if (media.gtMd) index = 3
  if (media.gtLg) index = 4

  return index
}
